import { render, staticRenderFns } from "./Notificator.vue?vue&type=template&id=05e59f9e&"
import script from "./Notificator.vue?vue&type=script&lang=js&"
export * from "./Notificator.vue?vue&type=script&lang=js&"
import style0 from "./Notificator.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports